// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rk3MBgnV6YEzpu {
  display: block;
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 64px 16px;
  overflow: auto;
  background: var(--ds-surface-raised, #ffffff);
  font-size: 18px;
  line-height: 24px;
  text-align: center;
}
.hMddwXxiOH0SLH {
  font-size: 24px;
  line-height: 32px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invitationLink": `Rk3MBgnV6YEzpu`,
	"description": `hMddwXxiOH0SLH`
};
export default ___CSS_LOADER_EXPORT___;
